angular.module('jv.Admin.Users')
    .controller('jvAdminUsersEmployeeAddController', [ '$scope', 'breadcrumbsResolve',
        function ($scope, breadcrumbsResolve) {
            $scope.flags.loading = false;
            $scope.breadcrumbsConfig = breadcrumbsResolve;
            $scope.breadcrumbsConfig.links.unshift({
                linkText: i18n['ADD_EMPLOYEE']
            });
        }]);